var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.29167,
    cy: 7.29167,
    r: 7.29167,
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.29167,
    cy: 24.7917,
    r: 7.29167,
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.29167,
    cy: 42.2917,
    r: 7.29167,
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7084,
    cy: 7.29167,
    r: 7.29167,
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7084,
    cy: 24.7917,
    r: 7.29167,
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7084,
    cy: 42.2917,
    r: 7.29167,
    fill: "#F3F3F5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEllipsis);
export default __webpack_public_path__ + "static/media/productEllipsis.4984cd09.svg";
export { ForwardRef as ReactComponent };